import { useEffect, useState } from 'react'
import { Divider } from 'components/divider'
import { ArrowLeftIcon, StarIcon } from '@heroicons/react/20/solid'
import { FEEDBACK_ADMIN_ACTION } from 'graphql/common/mutations'
import { t } from 'i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { ErrorDialog, SuccessDialog } from 'components/custom/ResponseDialog'

export default function FeedbackDetail() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const feedbackInfo = state?.feedbackInfo
    console.log(feedbackInfo)
    const [actionRemarks, setActionRemarks] = useState('')
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [dialogError, setDialogError] = useState('')
    useEffect(() => {
        if (feedbackInfo) {
            setActionRemarks(feedbackInfo?.admin_action.remarks || '')
        }
    }, [feedbackInfo])

    const handleBack = () => {
        navigate('/feedback')
    }
    //  MUtation Add Boat
    const [addFeedbackResponse, { loading: addLoading }] = useMutation(FEEDBACK_ADMIN_ACTION, {
        onCompleted: data => {
            if (
                data?.adminActionFeedbackResponse.code === '200' &&
                data?.adminActionFeedbackResponse.success === true
            ) {
                setShowSucDialog(true)
                setTimeout(() => {
                    handleBack()
                }, 500)
            } else {
                setDialogError(data?.adminActionFeedbackResponse.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setDialogError(error.message)
            setShowErrDialog(true)
        },
    })

    const handleDialogClose = () => {
        setShowSucDialog(false)
        setShowErrDialog(false)
    }
    const handleSubmitResponse = () => {
        addFeedbackResponse({
            variables: {
                adminAction: {
                    action_taken: true,
                    remarks: actionRemarks,
                },
                responseId: feedbackInfo?.response_id,
            },
        })
    }

    return (
        <>
            <div className="mb-6 flex justify-normal items-center">
                <button
                    onClick={handleBack}
                    type="button"
                    className="inline-flex items-center gap-x-0.5 rounded-md text-sm text-gray-600"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-4 rtl:rotate-180" />
                    {t('Back')}
                </button>
                <h3 className="text-lg font-bold leading-7 text-primary ps-2.5 pb-1">Feedback Info</h3>
            </div>

            <Divider />
            <div className="grid grid-cols-2 gap-6">
                <div className="mt-8">
                    <div className="px-4 sm:px-0">
                        <h3 className="text-lg font-semibold leading-7 text-primary">{t('Trip & Boat Info')}</h3>
                    </div>

                    <div className="mt-3 border-t border-gray-100">
                        <dl className="divide-y divide-gray-100">
                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                <dt className="text-sm font-medium leading-6 text-gray-900">{t('Trip date')}</dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {feedbackInfo?.response_info?.travel_date}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
            <Divider className="mt-5" />
            <div className="bg-white mt-5">
                <div className="mx-auto max-w-7xl px-6  lg:px-0 0">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-4">
                        <div className="lg:col-span-4">
                            <div className="px-4 sm:px-0">
                                <h2 className="text-base font-semibold leading-7 text-primary">{t('Feedback')}</h2>
                                <p className="mt-1 text-sm leading-6 text-gray-600">
                                    {t('View and manage feedback submitted by mobile app users.')}
                                </p>
                            </div>
                        </div>
                        <div className="mt-10 lg:col-span-7 lg:mt-0">
                            {feedbackInfo.response.map((feedback, index) => (
                                <>
                                    <dl className="space-y-10">
                                        <div>
                                            <dt className="text-base/7  text-gray-900">
                                                {feedback.order_no}. {feedback.question_text.en}
                                            </dt>
                                            <dd className="mt-2 text-base/7 text-gray-600">
                                                {feedback.question_type === 'OPEN_TEXT' ||
                                                feedback.question_type === 'YES_NO' ? (
                                                    <div className="text-md font-bold text-gray-700 ">
                                                        {feedback.user_value}
                                                    </div>
                                                ) : feedback.question_type === 'RATING' ? (
                                                    <div className="flex gap-3">
                                                        {[...Array(5)].map((_, i) => (
                                                            <StarIcon
                                                                key={i}
                                                                className={`w-6 h-6 ${
                                                                    i < feedback.user_value
                                                                        ? 'text-yellow'
                                                                        : 'text-gray-300'
                                                                }`}
                                                            />
                                                        ))}
                                                    </div>
                                                ) : null}
                                            </dd>
                                        </div>
                                    </dl>
                                    <Divider className="mt-3 mb-3" />
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="space-y-10 divide-y divide-gray-900/10 mt-6">
                <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3 pb-6">
                    <div className="px-4 sm:px-0">
                        <h2 className="text-base font-semibold leading-7 text-primary">{t('Action')}</h2>
                        <p className="mt-1 text-sm leading-6 text-gray-600">
                            {t('Enter the action taken for this feedback.')}
                        </p>
                    </div>
                    <div className="col-span-2">
                        <div>
                            <div className="grid max-w-full grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                                <div className="sm:col-span-full">
                                    <label
                                        htmlFor="description"
                                        className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        {t('Remarks')}
                                        <span className="text-red">*</span>
                                    </label>
                                    <textarea
                                        id="description"
                                        name="description"
                                        value={actionRemarks}
                                        onChange={e => setActionRemarks(e.target.value)}
                                        rows="4"
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>
                        </div>
                        {!feedbackInfo?.admin_action?.action_taken && (
                            <div className="mt-5 flex items-center justify-end gap-x-6 border-t border-gray-900/10 py-4 ">
                                <button type="button" className="text-sm font-semibold leading-6 text-gray-900">
                                    {t('Cancel')}
                                </button>
                                <button
                                    disabled={addLoading || actionRemarks === ''}
                                    onClick={handleSubmitResponse}
                                    type="submit"
                                    className={`justify-center rounded-md px-12 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 
                                        ${
                                            addLoading || actionRemarks === ''
                                                ? 'cursor-not-allowed bg-gray-300 text-gray-900 hover:bg-gray-400'
                                                : 'hover:bg-primary/[.9] bg-primary focus-visible:outline-primary'
                                        }`}
                                >
                                    {t('Save')}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showErrDialog && (
                <ErrorDialog status={true} title="Error" message={dialogError} onClose={handleDialogClose} />
            )}
            {showSucDialog && (
                <SuccessDialog
                    status={true}
                    title={t('Success')}
                    message={t('Saved Successfully')}
                    onClose={handleDialogClose}
                />
            )}
            {addLoading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
                </div>
            )}
        </>
    )
}
